module.exports = __webpack_public_path__ + "img/banner_service.c5b22a28.jpg";